import {
  Button,
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalFooter,
  ModalHeader,
  ModalOverlay,
} from "@chakra-ui/react";
import "cropperjs/dist/cropper.css";
import { createRef, useState } from "react";
import Cropper from "react-cropper";
import Dropzone from "./Dropzone";

const CoverUploadModal = ({
  title,
  onToggle,
  isOpen,
  onSubmit,
  croppedCanvasConfig,
  aspectRatio,
}) => {
  const [image, setImage] = useState(null);
  const [cropData, setCropData] = useState(null);
  const cropperRef = createRef();

  console.log(cropData);

  const onChange = (files) => {
    const reader = new FileReader();
    reader.onload = () => {
      setImage(reader.result);
    };
    reader.readAsDataURL(files[0]);
  };

  const handleSubmit = () => {
    if (typeof cropperRef.current?.cropper !== "undefined") {
      cropperRef.current?.cropper
        .getCroppedCanvas(croppedCanvasConfig)
        .toBlob((blob) => {
          if (blob) {
            const file = new File([blob], "cropped-image.jpg", {
              type: "image/jpeg",
              lastModified: Date.now(),
            });
            setCropData(file);
            onSubmit(
              file,
              cropperRef.current?.cropper.getCroppedCanvas().toDataURL()
            );
            setImage(null);
          }
        }, "image/jpeg");
    }
  };

  return (
    <Modal onClose={onToggle} isOpen={isOpen} size="xl">
      <ModalOverlay />
      <ModalContent>
        <ModalHeader>{title}</ModalHeader>
        <ModalCloseButton />
        <ModalBody>
          <div>
            <div style={{ width: "100%" }}>
              {!image ? (
                <Dropzone onChange={onChange} />
              ) : (
                <Cropper
                  ref={cropperRef}
                  style={{ height: 400, width: "100%" }}
                  zoomTo={0.5}
                  initialAspectRatio={1}
                  aspectRatio={aspectRatio}
                  src={image}
                  viewMode={1}
                  dragMode="move"
                  responsive={true}
                  cropBoxResizable={false}
                  checkOrientation={false}
                />
              )}
            </div>
          </div>
        </ModalBody>
        <ModalFooter>
          <Button tabIndex={6} onClick={onToggle}>
            Cancel
          </Button>
          <Button
            colorScheme="red"
            color="white"
            tabIndex={5}
            ml="3"
            onClick={handleSubmit}
          >
            Upload and Crop
          </Button>
        </ModalFooter>
      </ModalContent>
    </Modal>
  );
};

export default CoverUploadModal;
